import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Leftsidebarindustry from '../components/Leftsidebarindustry'
import Indusrtypagebanner from '../components/Indusrtypagebanner'
function DSA() {
  return (
    <div>
        <Header/>
       <Indusrtypagebanner/>

             <div className="service-details-section sp1">
    <div className="container">
        <div className="row">
            <Leftsidebarindustry/>

            <div className="col-lg-8">
                <div className="service-main-content heading1 padding1">
                    <h2>Direct Selling Agents (DSA)</h2>
                    <div className="space16"></div>
                   
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/industry/Industry_Focus/Direct_Selling_Agents.png" alt=""/>
                    </div>
                    <div className="space32"></div>
                  
                    <div className="space16"></div>
                     <p>In the fast-paced world of Direct Selling Agents (DSAs), performance, communication, and motivation are key drivers.</p>
                    <p>JBY Talent Acquisition & Management Private Limited specializes in sourcing result-oriented professionals for roles like field executives, telecallers, relationship managers, and loan advisors. </p>
                    <div className="space32"></div>
                    <p>We help DSAs across India build winning teams that can convert leads into loans effectively. Our recruitment process focuses on energy, experience, and customer-centricity—essential for thriving in the highly competitive financial services space.
                      Whether you're scaling your DSA network or launching a new financial product, JBY provides you with manpower that delivers results.
                    </p>
                    <div className="space32"></div>
            
                    <div className="space32"></div>
                 
                </div>
            </div>
        </div>
    </div>
</div>
        <Footer/>
      
    </div>
  )
}

export default DSA
